import type { PropsWithChildren } from 'react';
import { createContext, useCallback } from 'react';
import type { VisibilityOnDevicesValue } from '@elfsight/configurator-contracts';
import { useIsMobile } from '@elfsight/widget-utils';

type DisplayOnDevicesContextType = {
  isVisibleOnDevice: isVisibleOnDeviceType;
  isMobile?: boolean;
  windowWidth?: number;
};
export const DisplayOnDevicesContext =
  createContext<DisplayOnDevicesContextType | null>(null);

type isVisibleOnDeviceType = (
  mode: VisibilityOnDevicesValue | undefined
) => boolean;

interface DisplayOnDevicesProviderProps {
  widgetDisplayMode?: VisibilityOnDevicesValue;
  editMode?: boolean;
}

export const VisibilityOnDevicesProvider = ({
  children,
  widgetDisplayMode,
  editMode
}: PropsWithChildren<DisplayOnDevicesProviderProps>) => {
  const isMobile = useIsMobile();

  const isVisibleOnDevice: isVisibleOnDeviceType = useCallback(
    (mode = 'allDevices') => {
      if (editMode) return true;
      return (
        mode === 'allDevices' ||
        (isMobile && mode === 'mobileOnly') ||
        (!isMobile && mode === 'desktopOnly')
      );
    },
    [isMobile, editMode]
  );

  return (
    <DisplayOnDevicesContext.Provider value={{ isVisibleOnDevice }}>
      {isVisibleOnDevice(widgetDisplayMode) ? children : null}
    </DisplayOnDevicesContext.Provider>
  );
};
